import { PostAjaxAsync, State } from "@bapp/webcore"

const loginState = State({
  name: "loginState",
  initial: {
    mbb: "",
    password: null,
    authenticated: false,
    fetching: false
  },
  checkMbb(mbb: string) {
    const postData = {
      NextTransactionUrl: "INDAuthWebSecurity",
      Language: "tr-TR",
      MBB: mbb,
      TokenSessionId: "",
      TCKN: "",
      ChannelKey: "IND-RTL-WDS-MBB",
      DeviceOsType: "WEB",
      AppVersion: "",
      IsCaptchaRefresh: "false",
      UserAgent: "",
      Resolution: ""
    }
    return PostAjaxAsync({
      url: "https://direktbackendwebint.akbank.com/token",
      data: JSON.stringify(postData),
      onStart: () => {
        return {
          createAccountError: "",
          fetching: true
        }
      },
      onSuccess: (data: any) => {
        return {
          Captcha: data.Captcha,
          TokenSessionId: data.TokenSessionId,
          ShowUserName: data.ShowUserName,
          FastLogin: data.FastLogin,
          CaptchaRequestCount: data.CaptchaRequestCount,
          PblModulus: data.PblModulus,
          PblExponet: data.PblExponet,
          createAccountError: null
        }
      },
      onError: (err) => {
        return {
          createAccountError: err
        }
      },
      onFinally: () => {
        return {
          fetching: false
        }
      }
    })
  },
  logout() {
    const postData = {
      NextTransactionUrl: "ModAuth/Logout"
    }
    return PostAjaxAsync({
      data: JSON.stringify(postData),
      onStart: () => {
        return {
          fetching: true
        }
      },
      onSuccess: (response) => {
        return {}
      },
      onError: (err) => {
        return {}
      },
      onFinally: () => {
        return {
          fetching: false,
          access_token: "",
          authenticated: false
        }
      }
    })
  }
})

export default loginState
